module.exports = __webpack_public_path__ + "img/ai.e21a4f01.svg";